export enum ValidationErrorsEnum {
  REQUIRED = 'To pole jest wymagane',
  MIN_LENGTH = 'Wprowadzone dane nie spełniają minimalnej długości',
  MAX_LENGTH = 'Wprowadzone dane nie spełniają maksymalnej długości ',
  PATTERN = 'Wprowdzone dane nie spełniają reguł formatu',
  EMAIL = 'Wprowadzone dane nie spełniają reguł formatu dla adresu e-mail',
  MIN_DATE = 'Data nie może być wcześniejsza',
  MAX_DATE = 'Data nie może być póżniejsza',
  UNKNOWN = 'Wprowadzone dane są niepoprawne'
}
